<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      show-date
      :date-selected="''"
      :date-validation="false"
      :filter-names="['search', 'make', 'model']"
      search-label="search"
      @filterOption="onFiltersChange"
    >
      <template v-slot:registration_no="{ item }">
        <td class="">
          <div
            v-if="$admin.hasAccessTo('single-vehicle-trips.list')"
            class="imei-column"
          >
            <!-- @click="goToListingPage(item)" -->
            <!-- :to="{
                name: 'trip-listing',
                params: { imei: item.iot_imei },
                query: { vehicle_id: item.vehicle_id },
              }" -->
            <router-link :to="goToListingPage(item)">
              {{ item.registration_no }}
            </router-link>
          </div>
          <div v-else>
            {{ item.registration_no }}
          </div>
        </td>
      </template>

      <!-- add Filters -->
      <template #addFilters>
        <!-- <v-card>
          <v-text-field
            v-model="options.search"
            dense
            clearable
            :label="$t('select')"
            @change="fetchData"
          />
        </v-card> -->
      </template>
      <!-- add Filters -->

      <!-- Action Modals -->
      <template #actionModals>
        <!-- <v-toolbar
          flat
          class="action-toolbar"
        > -->

        <refresh-button
          v-if="list?.length > 0"
          :is-loading="isLoading"
          @reload="fetchData"
        />

        <!-- </v-toolbar> -->
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    refreshButton: () => import("@/components/base/RefreshButton.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      filters: {},
      subFilters: {},

      //

      groupId: "trips",
    };
  },

  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "trips/getLoading",
      meta: "trips/getMeta",
      list: "trips/getList",
    }),
    _headers() {
      const headers = [
        {
          text: this.$t("registration_no"),
          align: "left",
          sortable: true,
          value: "registration_no",
          width: "10%",
        },
        this.options.product
          ? {
              text:
                this.options.product == "oem"
                  ? this.$t("customer_name")
                  : this.$t("driver_name"),
              align: "left",
              sortable: false,
              con: true,
              value:
                this.options.product == "oem" ? "customer_name" : "driver_name",
              width: "10%",
            }
          : {
              text: "Name",
              align: "left",
              sortable: false,
              con: true,
              value: "driver_name",
              width: "10%",
            },

        {
          text: this.$t("make_and_model"),
          align: "left",
          sortable: false,
          value: "make_and_model",
          width: "10%",
        },
        {
          text: this.$t("total_trip_count"),
          align: "left",
          sortable: true,
          value: "total_trip_count",
          width: "10%",
        },
        {
          text: this.$t("last_trip_recevied_at"),
          align: "left",
          sortable: true,
          value: "last_trip_received_at",
          width: "10%",
        },
      ];
      return headers;
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
  },
  mounted() {
    this.$store.dispatch("trips/setLoadingValue", true);
  },
  beforeDestroy() {
    const params = {
      name: "trips",
      filters: this.options,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    async fetchData() {
      //  // Cancel any ongoing requests in the same group
      this.cancelRequestGroup();

      // Track the new request
      const controller = this.trackRequest();

      const params = {
        ...this.options,
        signal: controller.signal,
      };

      await this.$store.dispatch("trips/list", params).then(() => {});
    },

    goToListingPage(row) {
      const params = {
        product: this.options.product,
        fleetId: this.options.fleetId ?? undefined,
        oem_b2b_ids: this.options.oem_b2b_ids ?? undefined,
        tenant_id: this.options.tenant_id,
        search: this.options.search ?? undefined,
        vehicle_id: row.vehicle_id,
        page: this.options.page,
        perPage: this.options.itemsPerPage,
        md_make_id: this.options.md_make_id,
        md_model_id: this.options.md_model_id,
        dateType: this.options.dateType,
        date: this.options.date,
      };
      return {
        name: "trip-listing",
        params: { imei: row.iot_imei },
        query: params,
      };
    },

    //
  },
};
</script>
